import React, { PropsWithChildren } from 'react';
import { alpha, IconButton, Stack, StackProps } from '@mui/material';
import { ExpandLessOutlined } from '@mui/icons-material';

interface Props extends PropsWithChildren<StackProps> {
  isOpen: boolean;
  onToggle: () => void;
}

export const MetadataHeader: React.FC<Props> = ({ children, isOpen, onToggle, ...stackProps }) => {
  return (
    <Stack
      justifyContent="space-between"
      bgcolor={(theme) =>
        theme.vars
          ? `rgba(${theme.vars.palette.dividerChannel} / 0.1)`
          : alpha(theme.palette.divider, 0.1)
      }
      spacing={1}
      direction="row"
      {...stackProps}
    >
      {children}
      <IconButton onClick={onToggle}>
        <ExpandLessOutlined
          sx={{
            transition: 'transform 0.2s ease-in-out',
            transform: isOpen ? 'rotate(180deg)' : 'none',
          }}
        />
      </IconButton>
    </Stack>
  );
};
